module.exports = __webpack_public_path__ + "img/progress4.8ad0cdd2.png";